import React, { Component } from 'react';
import Container from '@/components/Container';
import Iframe from '@/components/Iframe';

export default class StatisticalExport extends Component {
  render() {
    const { search } = window.location;
    const IframeDom = Iframe({
      src: `https://t.xiaoyuanhao.com/v2/iframe/workFlow/statisticalExport${search}`,
    });

    return (
      <Container breStates>
        <IframeDom />
      </Container>
    );
  }
}
